import { AngularFireFunctions } from '@angular/fire/compat/functions';

import { Observable } from 'rxjs';
import {
  filter,
  switchMap,
} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { ListResponse } from '../../models/api.interface';
import { AuthService } from '../../modules/auth/services/auth.service';
import { FilterOptions } from './genericGridApi.model';

export class GenericGridApiService {



  protected serviceUrls = environment.urls.services;
  protected type;





  constructor(protected acf: AngularFireFunctions,
              protected authService: AuthService,
              opts) {
    this.type = opts.type;

  }

  compactFilter(filterObj) {

    return {
      c: filterObj.field,
      f: {
        type: 'contains',
        filterType: 'text',
        filter: filterObj.value
      }
    };

  }

  compactAGFilter(fieldName, filterOptions: FilterOptions) {

    return {
      f: filterOptions,
      c: fieldName
    };

  }

  find(options = {}, opts: any = {useCache: true, fieldBoolean: 'AND'}): Observable<ListResponse> {

    const callableName = this.serviceUrls[this.type].find;
    const findModal = this.acf.httpsCallable(callableName);

    const query = {
      filter: [],
      sortBy: [],
      sortDir: [],
      useCache: false,
      fieldBoolean: 'AND'
    };


    if (options) {
      for (const param of Object.keys(options)) {
        if (param === 'filterModel') {

          Object.entries(options[param]).forEach(([field, filterOptions]: [string, FilterOptions]) => {

            if (filterOptions.filterType === 'date') {
              query.filter.push(this.compactAGFilter(field, filterOptions));
            } else {
              query.filter.push(this.compactAGFilter(field, filterOptions));
            }
          });

        } else if (param === 'filter') {

          options[param].filters.forEach((filter) => {
            if (!query.hasOwnProperty(param)) {
              query[param] = [];
            }
            query[param].push(this.compactFilter(filter));
          });

        } else if (param === 'sortModel') {

          if (Array.isArray(options[param])) {
            options[param].forEach((srt) => {
              if (srt.sort) {
                query.sortBy.push(srt.colId);
                query.sortDir.push(srt.sort);
              }
            });
          }

        } else if (param === 'sort') {

          if (Array.isArray(options[param])) {
            options[param].forEach((srt) => {
              if (srt.dir) {
                query.sortBy.push(srt.field);
                query.sortDir.push(srt.dir);
              }
            });
          }

        } else {
          query[param] = options[param];
        }
      }

      if (opts.useCache) {
        query.useCache = true;
      }
      if(opts.fieldBoolean)
        query.fieldBoolean = opts.fieldBoolean;
    }


    return this.authService.appUser$.pipe(filter((appUser) => !!appUser),
      switchMap(appUser => findModal({
        customerId: appUser.customer.customerId,
        query
      })));
  }

}
